<div class="field">
    <label class="col-fixed title-row"></label>
    <div class="col input-row with-info">
        <p-calendar styleClass="w-12" (onSelect)="onSelectCalendarValue($event)" [defaultDate]="minDate"
        dataType="date" [(ngModel)]="param" [showTime]="true" hourFormat="24" [minDate]="minDate"
        [readonlyInput]="true" [showIcon]="true" appendTo="body" (onClose)="onClose($event)"></p-calendar>
    </div>
  </div>
